import * as React from 'react';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import UIModal from '@mui/material/Modal';
import { Box, DialogContentText, DialogTitle, Typography } from '@mui/material';
import styles from './style.module.css';
import { useState } from 'react';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import Button from '@mui/material/Button';

interface DeleteConfirmationModalProps {
  open: boolean;
  onClose: () => void;
  children?: React.ReactNode;
  title: string | React.ReactNode;
  shouldPreventModal?: boolean;
}

const style = {
  position: 'absolute' as 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  bgcolor: 'background.paper',
  boxShadow: 24,
};

export const Modal = ({
  onClose,
  open,
  children,
  title,
  shouldPreventModal,
}: DeleteConfirmationModalProps) => {
  const [confirmOpen, setConfirmOpen] = useState(false);

  const closeHdl = () => {
    shouldPreventModal ? setConfirmOpen(true) : onClose();
  };

  const handleConfirmClose = () => {
    setConfirmOpen(false);
    onClose();
  };
  return (
    <>
      <UIModal
        open={open}
        onClose={closeHdl}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <Box sx={style}>
          <div className={styles.headerContainer}>
            <div className={styles.header}>
              {typeof title === 'string' ? (
                <Typography variant="h6">{title}</Typography>
              ) : (
                title
              )}
              <IconButton
                aria-label="close"
                onClick={closeHdl}
                sx={{ color: (theme) => theme.palette.grey[500] }}
              >
                <CloseIcon />
              </IconButton>
            </div>
          </div>
          <div className={styles.body}>{children}</div>
        </Box>
      </UIModal>
      <Dialog open={confirmOpen} onClose={() => setConfirmOpen(false)}>
        <DialogTitle>{'Confirm Close'}</DialogTitle>
        <DialogContent>
          <DialogContentText>
            Are you sure you want to close the modal?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setConfirmOpen(false)}>Cancel</Button>
          <Button color="error" onClick={handleConfirmClose} autoFocus>
            Confirm
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};
